export const setStepValidity = stepsValidity => ({
  type: 'SET_STEPBOX_ERRORS',
  stepsValidity
})

export const showStepBoxErrors = showErrors => ({
  type: 'SHOW_STEPBOX_ERRORS',
  showErrors
})



// WEBPACK FOOTER //
// ./src/app/modules/StepBox/actions.js